import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const AlandIslands: Country = {
    identifier: "AlandIslands",
    name: "Aland Islands",
    countryCode: "AX",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇦🇽",
    svgPath: "m 530.99575,250.1104 0.086,0.001 0.039,-0.048 0.15,0.034 0.226,0.219 0.046,0.119 0.155,0.061 0.054,0.123 -0.18,0.382 -0.111,0.007 -0.083,-0.048 -0.147,0.042 -0.086,0.072 -0.029,0.159 0.005,0.332 -0.657,0.066 -0.151,-0.097 -0.207,-0.755 0.042,-0.196 0.139,-0.083 0.119,-0.018 0.018,0.408 0.175,-0.041 0.055,-0.269 0.012,-0.189 -0.047,-0.096 -0.119,-0.074 -0.069,-0.127 0.099,-0.205 0.183,-0.089 0.158,0.274 0.125,0.036 z m -0.919,0.927 0.015,0.126 -0.107,-0.032 -0.083,0.043 -0.056,0.155 -0.122,-0.056 -0.049,-0.223 0.091,-0.334 0.217,-0.013 0.094,0.334 z m 2.664,0.823 -0.022,0.133 -0.229,0.029 -0.096,-0.118 -0.214,0.015 -0.037,-0.059 0.089,-0.118 0.17,-0.074 0.222,0.03 0.117,0.162 z",
}
